import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp('https?://open.spotify.com/(.*)$');
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const { newUrl, height } = React.useMemo(() => {
    try {
      const parsedUrl = new URL(url);
      const pathname = parsedUrl.pathname.replace(/^\/intl-[a-z]+/, '');

      const normalizedPath = pathname.replace(/^\/embed/, '');

      let heightSet;

      if (
        normalizedPath.includes('episode') ||
        normalizedPath.includes('show')
      ) {
        heightSet = 232;
      } else if (normalizedPath.includes('track')) {
        heightSet = 80;
      } else {
        heightSet = 380;
      }

      const src = `https://open.spotify.com/embed${normalizedPath}`;

      return { newUrl: src, height: `${heightSet}px` };
    } catch (err) {
      return { newUrl: '', height: '0px' };
    }
  }, [url]);

  return (
    <Portal
      url={newUrl}
      title="Spotify Embed"
      {...rest}
      fullHeight
      withMetadata
      height={height}
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'spotify-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: false,
  }),
  addCommandOption: {
    title: 'Spotify',
    description: 'Embed a Spotify player.',
    searchTerms: ['embed', 'spotify'],
    icon: 'tabler:brand-spotify',
  },
});
